import React from 'react';

import loadScript from 'lib/loadScript';

import styles from './styles.module.scss';

class ElectionsNav extends React.Component {
  componentDidMount() {
    this.loadPymScript();
  }

  loadPymScript() {
    let embedUrl = 'https://www.nbcnews.com/politics/2020-elections/recirc-nav/embed/borders';
    loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
      .then(() => {
        if (window.pym) {
          // Strip query string params from url that might have been copied from development.
          embedUrl = embedUrl.replace(/&(childId|parentUrl)=[^&]+/g, '');
          // Pym adds iframe and establishes communication for controlling height.
          this.pymChild = new window.pym.Parent('electionsNav', embedUrl);
        }
      });
  }

  render() {
    return (
      <div id="electionsNav" className={styles.electionsNav} data-test="elections-nav" />
    );
  }
}

export { ElectionsNav };
